export const SET_M5_REQUEST = 'SET_M5_REQUEST';
export const SET_M5_FAILED = 'SET_M5_FAILED';
export const SET_M5_SEGMENT_LIST_SUCCESS = 'SET_M5_SEGMENT_LIST_SUCCESS';
export const SET_M5_OPPORTUNITY_LIST_SUCCESS = 'SET_M5_OPPORTUNITY_LIST_SUCCESS';
export const SET_M5_SEGMENT_SUCCESS = 'SET_M5_SEGMENT_SUCCESS';
export const CLEAN_M5 = 'CLEAN_M5';
